import React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';

function Research({ title, content, link }) {
  return (
    <Box>
      <Typography
        variant="desktopH3"
        sx={{ marginBottom: '24px' }}
        color="kit.text.main"
      >
        {title}
      </Typography>
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            flexGrow: 1,
            margin: 'auto',
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              xl={6}
              sx={{
                paddingBottom: {
                  xs: '16px',
                  xl: '0',
                },
              }}
            >
              <Typography variant="desktopP2">{content}</Typography>
            </Grid>
            <Grid item xs={12} xl={6}>
              <Link
                to={link.url}
                target="_blank"
                sx={{
                  textDecoration: 'none',
                }}
              >
                <Button
                  variant="kitPrimary"
                  size="medium"
                  component="span"
                  tabIndex={-1}
                  sx={{
                    minWidth: '236px',
                  }}
                >
                  {link.title}
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default Research;
